module.exports = __webpack_public_path__ + "img/guide_img02.8ff2ae69.jpg";